module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "p-dataview-layout-options p-selectbutton p-buttonset"
  }, [_c('button', {
    class: _vm.buttonListClass,
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        return _vm.changeLayout('list')
      }
    }
  }, [_c('i', {
    staticClass: "pi pi-bars"
  })]), _vm._v(" "), _c('button', {
    class: _vm.buttonGridClass,
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        return _vm.changeLayout('grid')
      }
    }
  }, [_c('i', {
    staticClass: "pi pi-th-large"
  })])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-06c58179"}!./~/vue-loader/lib/selector.js?type=template&index=0!./~/primevue/dataviewlayoutoptions/DataViewLayoutOptions.vue
// module id = 2020
// module chunks = 0